








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import { maskDateTime } from '@/utils/common'

@Component
export default class AuditLogHistory extends Vue {
  @Prop({ required: true }) entityName!: string
  @Prop({ required: true }) entityId!: string

  loading: boolean = false
  logs: any[] = []

  mounted() {
    this.fetchLogs()
  }

  @Watch('entityId')
  onEntityIdChange() {
    this.fetchLogs()
  }

  async fetchLogs() {
    if (!this.entityId) {
      this.logs = []
      return
    }

    this.loading = true
    try {
      const response = await RemuneracaoMedicaApi.getAuditLog({
        entityName: this.entityName,
        entityId: this.entityId
      })
      if (response.success && response.data) {
        this.logs = response.data
      } else {
        this.logs = []
      }
    } catch (e) {
      console.error('Erro ao buscar histórico de auditoria:', e)
      this.logs = []
    } finally {
      this.loading = false
    }
  }

  formatDateTime(date: string) {
    if (!date) return ''
    return maskDateTime(date)
  }

  translateAction(action: string) {
    switch (action) {
      case 'Create':
        return 'Criação'
      case 'Update':
        return 'Edição'
      case 'Delete':
        return 'Exclusão'
      default:
        return action
    }
  }

  getActionColor(action: string) {
    switch (action) {
      case 'Create':
        return 'green darken-2'
      case 'Update':
        return 'blue darken-2'
      case 'Delete':
        return 'red darken-2'
      default:
        return 'grey'
    }
  }

  parseChanges(changesStr: string): any[] {
    if (!changesStr) return []
    try {
      const parsed = JSON.parse(changesStr)
      if (Array.isArray(parsed)) return parsed
      return []
    } catch (e) {
      return []
    }
  }

  isBase64Image(val: any): boolean {
    if (!val || typeof val !== 'string') return false
    return val.startsWith('data:image')
  }

  formatValue(val: any): string {
    if (val === null || val === undefined || val === '') return '-'
    if (typeof val === 'boolean') return val ? 'Sim' : 'Não'
    return String(val)
  }
}
